import { Translate } from 'react-redux-i18n'
import TooltipExpression from '../../common/tooltipExpression'

export const CHARTS = [
  {
    title: 'financialAnalysis.LOANS_TO_DEPOSIT',
    dataKey: 'RT0277',
    color: '#006AA6',
  },
  {
    title: 'financialAnalysis.LIQUID_ASSETS_TO_TOTAL_LIABILITIES',
    dataKey: 'FA111',
    color: '#F49966',
    tooltipContent: (
      <TooltipExpression
        style={{ alignItems: 'unset' }}
        expressions={[
          {
            text: <Translate value="financialAnalysis.TOTAL_LIABILITIES_1" />,
            operator: '=',
            styleContainer: { alignItems: 'unset' },
          },
          {
            text: (
              <>
                <Translate value="financialAnalysis.TOTAL_LIABILITIES_2" />
                <br />
                +&nbsp;
                <Translate value="financialAnalysis.TOTAL_LIABILITIES_3" />
                <br />
                +&nbsp;
                <Translate value="financialAnalysis.TOTAL_LIABILITIES_4" />
                <br />
                +&nbsp;
                <Translate value="financialAnalysis.TOTAL_LIABILITIES_5" />
                <br />
                <Translate value="financialAnalysis.TOTAL_LIABILITIES_6" />
              </>
            ),
            styleText: { textAlign: 'unset' },
            styleContainer: { alignItems: 'unset' },
          },
        ]}
      />
    ),
  },
  {
    title: 'financialAnalysis.AVERAGE_COST_OF_FINANCING',
    dataKey: 'FA149',
    color: '#C06C84',
    tooltipContent: (
      <TooltipExpression
        expressions={[
          {
            text: (
              <Translate value="financialAnalysis.NON_BANK_AVERAGE_COST_OF_FINANCING_1" />
            ),
            operator: '=',
          },
          {
            text: (
              <Translate value="financialAnalysis.AVERAGE_COST_OF_FINANCING_2" />
            ),
            isDivide: true,
            textUnder: (
              <Translate value="financialAnalysis.AVERAGE_COST_OF_FINANCING_3" />
            ),
          },
        ]}
      />
    ),
  },
]
